import React from "react";
import { useSelector } from "react-redux";

import styles from './styles.module.scss';
import FordActualScoreCardFilters from "modules/reporting/fordReports/actualScorecard/filters";
import FordScoreCards from "modules/reporting/fordReports/actualScorecard/sections";
import FordScoreTableWrapper from "modules/reporting/fordReports/actualScorecard/table";

const FordActualScoreCard = () => {
  const {
    fordDashboardReducer: { actualScoreCardReducer }
  } = useSelector((state) => state);

  return (
    <section className={styles.actualScoreCardWrapper}>
      <FordActualScoreCardFilters />
      <FordScoreCards filters={actualScoreCardReducer.filters} />
      <FordScoreTableWrapper />
    </section>
  );
};

export default React.memo(FordActualScoreCard);
